// extracted by mini-css-extract-plugin
export default {"logo":"logo_logo__be62F","img":"logo_img__GWD9T"};